'use strict';

import mod from './ngmodule';
import '../common/web-service-url';
import './persistant-storage';

export default mod;